import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ApiSystemSettingsConstants } from "../../constants/api-constants/api-system-settings.constants";
import { firstValueFrom } from "rxjs";
import { Router } from "@angular/router";
let SystemSettingService = class SystemSettingService {
    http;
    router;
    systemSettings;
    maintenanceModeEnabled = false;
    maintenanceAcknowledged = false;
    constructor(http, router) {
        this.http = http;
        this.router = router;
    }
    async loadSettings() {
        this.maintenanceAcknowledged = false;
        const httpParams = new HttpParams().set("filters", "key eq 'maintenance_mode'");
        try {
            this.systemSettings = await firstValueFrom(this.http.get(`${ApiSystemSettingsConstants.URL}/0/${ApiSystemSettingsConstants.FUNCTION_GET_PUBLIC_SYSTEM_SETTINGS}`, { params: httpParams }));
        }
        catch (err) {
            console.error(`${ApiSystemSettingsConstants.URL}`, httpParams, err);
            this.systemSettings.value = [];
        }
    }
    get(key) {
        return this.systemSettings.value.find(x => x.key === key)?.value;
    }
    isMaintenanceModeEnabled() {
        //return false;
        const maintenanceMode = this.systemSettings?.value.find(x => x.key === "maintenance_mode")?.value;
        if (maintenanceMode !== null && maintenanceMode !== undefined) {
            this.maintenanceModeEnabled = JSON.parse(maintenanceMode).enabled;
        }
        return this.maintenanceModeEnabled;
    }
    setMaintenanceAcknowledged() {
        this.maintenanceAcknowledged = true;
    }
    getMaintenanceAcknowledged() {
        return this.maintenanceAcknowledged;
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: Router }
    ];
};
SystemSettingService = __decorate([
    Injectable({
        providedIn: "root"
    })
], SystemSettingService);
export { SystemSettingService };
